class SizeGuide extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this._handleClick.bind(this));
  }

  _handleClick(event) {
    const button = event.target.closest('.size-guide__unit-btn');
    if (!button) return;

    const unit = button.dataset.unit;
    if (!unit || unit === this.dataset.unit) return;

    this.dataset.unit = unit;
    this.querySelectorAll('.size-guide__unit-btn').forEach((btn) => {
      btn.classList.toggle('--active', btn.dataset.unit === unit);
    });
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide);
}
